const jobs = [
	{
		id: 0,
		title: 'Junior Developer',
		company: 'The Gig',
		location: 'Hamilton, New Zealand',
		dateRange: 'July 2020 - Nov 2020',
		url: 'https://thegigwebsite.web.app/', description: [
			'Developing and Testing code with documentation in each sprint.'
		]
	},
	{
		id: 1,
			title: 'Freelancer',
			company: "Yakeda's Gift Store",
			location: 'Hamilton, New Zealand',
			dateRange: 'Sep 2020 - Ongoing',
			url: 'https://yakedas.co.nz',
			description: [
				'Coaching owner and other staffs on setting up menus, nested menus, adding products, tracking the inventory, etc.',
			]
	},
	{
		id: 2,
		title: 'IT Technician',
		company: 'Birat Kshitiz College',
		location: 'Biratnagar, Morang',
		dateRange: 'June 2017 - June 2019',
		url: 'http://kshitiz.edu.np/',
		description: [
			'Maintaining and administering computer networks and related computing environments including systems software, applications software, hardware and configurations.',
			'Configuring and testing LAMP stack, computer hardware, and operating system software.'
		]
	}
];

export default jobs;
